"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STRATOS_HOST = exports.PERFORMANCE_MATERIALS_PATH = exports.NEXT_COMMERCE_PORTS = exports.GQL_API = exports.DEFAULT_LOCALE = exports.ASSET_HOST = exports.AEM_AUTHOR_PORTS = exports.AEM_AUTHOR_HOST = void 0;
var DEFAULT_LOCALE = {
  country: 'US',
  language: 'en'
};
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
var PERFORMANCE_MATERIALS_PATH = '/performance-materials';
exports.PERFORMANCE_MATERIALS_PATH = PERFORMANCE_MATERIALS_PATH;
var NEXT_COMMERCE_PORTS = ['30013',
// stratos
'30023',
// next-commerce-china
'30050',
// stratos nginx
'31013',
// utc on DEV machine
'80',
// http default port
'443',
// https default port
'',
// external site default port
'3000' // next-commerce localhost
];
exports.NEXT_COMMERCE_PORTS = NEXT_COMMERCE_PORTS;
var AEM_AUTHOR_PORTS = ['4502',
// aem author non-secure
'4503',
// aem publisher non-secure
'8442',
// aem author https
'8443',
// aem publisher https
'4000' // aem-cms nextjs localhost
];
exports.AEM_AUTHOR_PORTS = AEM_AUTHOR_PORTS;
var STRATOS_HOST = {
  PROD: 'https://www.sigmaaldrich.com',
  QA: 'https://wwwqws.sigmaaldrich.com',
  DEV: 'https://wwwdws.sigmaaldrich.com'
};
exports.STRATOS_HOST = STRATOS_HOST;
var ASSET_HOST = 'https://stlpaemass01.sial.com:8442';
exports.ASSET_HOST = ASSET_HOST;
var GQL_API = {
  PROD: "".concat(STRATOS_HOST.PROD, "/api"),
  QA: "".concat(STRATOS_HOST.QA, "/api"),
  DEV: "".concat(STRATOS_HOST.DEV, "/api")
};
exports.GQL_API = GQL_API;
var AEM_AUTHOR_HOST = {
  PROD: 'stlpaem',
  QA: 'stlqaem',
  DEV: 'stlwcmdev',
  DEVAUTH: 'ussl1x100452',
  QAPUB: 'ussl1x0006'
};
exports.AEM_AUTHOR_HOST = AEM_AUTHOR_HOST;